import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { blue, brown, cyan, green, grey, indigo, lime, orange, pink, purple, red, yellow } from "@mui/material/colors";
import React from "react";

// Extended color set for more words
const colorSet = [
    red[300], orange[300], yellow[300], green[300], blue[300], 
    indigo[300], purple[300], cyan[300], lime[300], pink[300], 
    brown[300], grey[300]
];

export default function AllPuzRow({ rowIndex, row, allWordPositions, displayIndex }) {
    return (
        <Box
            sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
            }}
        >
            {row.map((r, colIndex) => {
                let color = "transparent";
                let wordIndex = -1;

                // Handle both string and array cases for r
                let uniqueR;
                if (Array.isArray(r)) {
                    uniqueR = [...new Set(r.filter(val => val !== ''))];
                } else {
                    uniqueR = r !== '' ? r : '';
                }

                // Check if this cell is part of any word
                if (allWordPositions) {
                    for (let i = 0; i < allWordPositions.length; i++) {
                        const found = allWordPositions[i].positions.find(
                            (p) => p.row === rowIndex && p.col === colIndex
                        );
                        if (found) {
                            wordIndex = i;
                            color = colorSet[i % colorSet.length];
                            break;
                        }
                    }
                }

                return (
                    <Box
                        key={colIndex}
                        sx={{
                            border: "1px solid black",
                            width: "50px",
                            height: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            backgroundColor: color,
                        }}
                    >
                        {displayIndex ? (
                            <>
                                <Typography variant="h6" fontWeight="bold">
                                    {uniqueR}
                                </Typography>
                                <Typography variant="caption">{`(${rowIndex}, ${colIndex})`}</Typography>
                            </>
                        ) : (
                            <Typography variant="body1" fontWeight="bold">
                                {uniqueR}
                            </Typography>
                        )}
                    </Box>
                );
            })}
        </Box>
    );
}

